<div class="container-fluid">
    <div class="d-flex justify-content-between align-items-center detail-header">
        <h1>Screen Detail</h1>
        <button mat-flat-button color="primary" (click)="onBack()">
            <mat-icon>arrow_back</mat-icon>
            Back to Screens
        </button>
    </div>

    <div class="card overflow-auto detail-shell" appDynamicHeight [offset]="140" [minHeight]="300">
        @if (summary) {
        <div class="row p-0 m-0">
            <div class="container p-3 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                <div class="d-flex justify-content-between align-items-center pb-1">
                    <div class="fw-bold fs-6 p-2">Screen Detail</div>
                </div>

                <hr />

                <div class="screen-hero d-flex align-items-center gap-3 px-2 pb-3">
                    <div class="screen-preview">
                        @if (summary.screenImageUrl) {
                        <img class="screen-thumbnail" [src]="summary.screenImageUrl"
                            [alt]="summary.screenName + ' thumbnail'" (error)="summary.screenImageUrl = null" />
                        }
                        @else {
                        <div class="screen-hero-icon">
                            <mat-icon>developer_board</mat-icon>
                        </div>
                        }
                    </div>
                    <div>
                        <div class="screen-name">{{ summary.screenName }}</div>
                        <div class="screen-subtitle">Screen ID: {{ summary.screenId }}</div>
                        <div class="screen-subtitle">Code: {{ summary.screenCode }}</div>
                    </div>
                </div>

                <table class="table table-bordered detail-table">
                    <tbody>
                        <tr>
                            <th>Business ID</th>
                            <td>{{ summary.businessId }}</td>
                        </tr>
                        <tr>
                            <th>Business Type</th>
                            <td>{{ summary.businessType }}</td>
                        </tr>
                        <tr>
                            <th>Device Type</th>
                            <td>{{ summary.deviceType }}</td>
                        </tr>
                        <tr>
                            <th>Resolution</th>
                            <td>{{ summary.resolution }}</td>
                        </tr>
                        <tr>
                            <th>Player Version</th>
                            <td>{{ summary.playerVersion }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="container p-3 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                <div class="d-flex justify-content-between align-items-center pb-1">
                    <div class="fw-bold fs-6 p-2">Screen Status</div>
                </div>

                <hr />

                <table class="table table-bordered detail-table">
                    <tbody>
                        <tr>
                            <th>Operational Status</th>
                            <td>
                                <span class="status-badge" [ngClass]="getStatusClass(summary.operationalStatus)">
                                    {{ summary.operationalStatus }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th>Active State</th>
                            <td>
                                <span class="status-badge" [ngClass]="getStatusClass(summary.activeState)">
                                    {{ summary.activeState }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th>Filler Ad</th>
                            <td>
                                <span class="status-badge"
                                    [ngClass]="summary.fillerAd === 'ENABLED' ? 'status-live' : 'status-inactive'">
                                    {{ summary.fillerAd }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th>Registered</th>
                            <td>{{ summary.registered }}</td>
                        </tr>
                        <tr>
                            <th>Heartbeat</th>
                            <td>{{ summary.heartbeat }}</td>
                        </tr>
                        <tr>
                            <th>Last Ping</th>
                            <td>{{ summary.lastPing }}</td>
                        </tr>
                        <tr>
                            <th>OS Version</th>
                            <td>{{ summary.osVersion }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <hr />

            <div class="container p-3 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="d-flex justify-content-between align-items-center pb-1">
                    <div class="fw-bold fs-6 p-2">Main Screen Details</div>
                </div>

                <hr />

                <table class="table table-bordered detail-table">
                    <tbody>
                        @for (field of mainDetails; track field.label) {
                        <tr>
                            <th>{{ field.label }}</th>
                            <td>{{ field.value }}</td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>

            <hr />

            <div class="container p-3 col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <div class="d-flex justify-content-between align-items-center pb-1">
                    <div class="fw-bold fs-6 p-2">System</div>
                </div>

                <hr />

                <table class="table table-bordered detail-table">
                    <tbody>
                        @for (field of systemDetails; track field.label) {
                        <tr>
                            <th>{{ field.label }}</th>
                            <td>{{ field.value }}</td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>

            <div class="container p-3 col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <div class="d-flex justify-content-between align-items-center pb-1">
                    <div class="fw-bold fs-6 p-2">Hardware</div>
                </div>

                <hr />

                <table class="table table-bordered detail-table">
                    <tbody>
                        @for (field of hardwareDetails; track field.label) {
                        <tr>
                            <th>{{ field.label }}</th>
                            <td>{{ field.value }}</td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>

            <div class="container p-3 col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <div class="d-flex justify-content-between align-items-center pb-1">
                    <div class="fw-bold fs-6 p-2">Connectivity</div>
                </div>

                <hr />

                <table class="table table-bordered detail-table">
                    <tbody>
                        @for (field of connectivityDetails; track field.label) {
                        <tr>
                            <th>{{ field.label }}</th>
                            <td>{{ field.value }}</td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
        }
        @else {
        <div class="p-3">Loading...</div>
        }
    </div>
</div>
